import { useRouter } from "next/router";
import { useEffect, useState } from "react";
import { css } from "styled-components";
import {
  hideAboveMobile,
  hideOnMobile,
  mediumScreenAndBelow,
} from "../../../lib/mediaQuery";
import { Icon } from "../../Icon";
import { Headline, Subhead } from "../../Typography";
import { Button } from "../../buttons/Button";

interface Props {
  destination?: string;
  label?: string;
  className?: string;
}

export const BackButton = ({
  destination,
  label = "Back",
  className,
}: Props) => {
  const [updatedDestination, setUpdatedDestination] = useState<string>();
  const router = useRouter();

  useEffect(() => {
    if (typeof window !== "undefined") {
      if (window.history.length <= 2 && !destination) {
        setUpdatedDestination("/");
      } else {
        setUpdatedDestination(destination);
      }
    }
  }, []);

  const handleClick = () => {
    Boolean(updatedDestination)
      ? router.push(updatedDestination)
      : router.back();
  };

  return (
    <Button
      variant="transparent"
      onClick={handleClick}
      icon={
        <Icon
          name={"BackArrow"}
          css={`
            margin-right: var(--spacing-xs);
            width: 15px;
            height: 15px;
          `}
        />
      }
      css={`
        width: auto;
        margin: 0;
        max-height: 40px;
        ${mediumScreenAndBelow(css`
          display: none;
        `)}
      `}
      className={className}
    >
      <Headline css={hideOnMobile}>{label}</Headline>
      <Subhead css={hideAboveMobile}>{label}</Subhead>
    </Button>
  );
};
